<!-- section template -->
<template>
  <el-dialog :visible.sync="dialog2MixinVisible" :custom-class="`${$style.dialogAlerrtSuccessAdd} isStyleLogin text-center`" width="738px" append-to-body @closed="$Dialog2MixinOnDestroy">
    <div class="dialogAlerrtSuccessAdd__content"> 已加入待完成預約清單 </div>
    <div class="warning">尚未完成預約</div>
    <div class="sub-content"> 點擊『下一步』完成預約付款後預約才會成立 </div>
    <hr />
    <BaseButton class="isStylePrimary isFull" :class="{ isRadius: $globalIsJtails }" @click="toCheckOut"> 下一步 </BaseButton>
    <BaseButton class="isStyleDark isOutline3 isFull mt-4" :class="{ isRadius: $globalIsJtails }" @click="toAddNew"> 再預約一筆 </BaseButton>
  </el-dialog>
</template>

<script>
import { merchantComputed } from '@store/helpers'
import dialog2Mixin from '../mixins/dialog2'
import { memberPetOptions } from '@utils/ipetbooking-options'
import formatDate from '@utils/format-date'

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      cartType: '',
      value: {}, // submitData
      cart: {}, // 購物車
    }
  },
  computed: {
    ...merchantComputed,
    memberPetOptions,
    currentMemberPet() {
      return this.value.petId
        ? this.memberPetOptions.find((item) => {
            return item.id === this.value.petId
          })
        : {}
    },
  },
  methods: {
    formatDate,
    toAddNew() {
      this.$router.push({
        name: 'reservation',
        params: {
          storeAlias: this.value.storeAlias,
        },
      })
      this.$Dialog2MixinOnDestroy()
    },
    toCheckOut() {
      this.$router.push({
        name: 'reservation-checkout',
      })
      this.$Dialog2MixinOnDestroy()
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.dialogAlerrtSuccessAdd {
  :global {
    .warning {
      display: inline-block;
      color: #ec5151;
      background-color: #fef1f1;
      padding: 4px 8px;
      margin: 8px 0;
    }
    .sub-content {
      color: #726f65;
      font-size: 12px;
    }
    .dialogAlerrtSuccessAdd {
      &__content {
        font-size: 1.125rem;
        line-height: 2;
        color: $color-primary;
        text-align: center;
        font-weight: 500;
      }
    }
  }
}
@media (min-width: 992px) {
  .dialogAlerrtSuccessAdd {
    :global {
      .sub-content {
        font-size: 14px;
      }
    }
  }
}
</style>
